import paymentBrands from 'core/common/assets/images/paymentForm/secure-brands.png';
import { Stack, Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { Address } from '../../Address';

import { BrandsImageStyled, GuaranteeIconStyled } from './styled';

export const PaymentDescription = ({ guaranteeText }: { guaranteeText?: string }) => (
  <>
    {guaranteeText && (
      <Stack direction="row" alignItems="center" justifyContent="center" gap={2}>
        <GuaranteeIconStyled name="guarantee" width={24} height={24} />
        <Typography
          variant="bodySmallRegular"
          dangerouslySetInnerHTML={prepareHtml(guaranteeText)}
        />
      </Stack>
    )}
    <BrandsImageStyled src={paymentBrands} alt="Payment brands" />
    <Address />
  </>
);
